import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import SelectInput from '../../../../../modules/react/components/stateful/SelectInput';

const GET_LISTINGS = gql`
  query GetListings($type: String) {
    listings(type: $type) {
      facility {
        id
        displayName
        address {
          fullAddress
        }
      }
    }
  }
`;

const propTypes = {
  load: PropTypes.func.isRequired,
  loaded: PropTypes.bool.isRequired,
  options: PropTypes.object.isRequired,
  facilityId: PropTypes.string,
};

const defaultProps = {
  facilityId: '',
};

const FacilitySelectInput = ({ facilityId, ...rest }) => {
  const { data, loading, error } = useQuery(GET_LISTINGS, { variables: { type: 'full' }, ssr: false });

  if (!data || loading) {
    return null;
  }

  const allFacilities = error
    ? []
    : data.listings.map(listing => listing.facility);

  const selectOptions = {};

  allFacilities.forEach(({
    id,
    displayName,
    address: { fullAddress },
  }) => {
    selectOptions[id] = `${displayName} - ${fullAddress}`;
  });

  return <SelectInput options={selectOptions} {...rest} htmlSelect />;
};

FacilitySelectInput.propTypes = propTypes;
FacilitySelectInput.defaultProps = defaultProps;

export default FacilitySelectInput;
